<template>
  <CModal @mtdclosemodal="mtdClose" :show="boo_modal" :title="title" :size="'xl'" :centered="true" :btn_cancel="true"
    :btn_ok="true" :booTitile="true">
    <div class="container">
      <CRow>
        <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 mt-0 text-center">
          <label class="form-label text-center"><strong>Billetes</strong></label>
          <div v-for="(item, index) in billetes" :key="index" class="">
            <CInput :append="item.total == 0 ? '0.00' : item.total" disabled placeholder="0" v-model="item.cantidad">
              <template #prepend-content>{{ item.label }}</template>
            </CInput>
          </div>
        </div>
        <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12 text-center">
          <label class="form-label text-center"><strong>Monedas</strong></label>
          <div v-for="(item, index) in monedas" :key="index" class="">
            <CInput :append="item.total == 0 ? '0.00' : item.total" disabled placeholder="0" v-model="item.cantidad">
              <template #prepend-content>{{ item.label }}</template>
            </CInput>
          </div>
        </div>
      </CRow>
    </div>
    <template #footer>
      <CButton class="btn-secondary" @click="mtdClose" :style="{ color: 'black' }">
        <i class="fa fa-times"></i>&nbsp;Cerrar
      </CButton>
    </template>
  </CModal>
</template>
<script>
import CModal from "../../shared/modals/cModalFormCom.vue";

export default {
  name: "c-reportquote-modal",
  components: {
    CModal,
  },
  data() {
    return {
      swal: null,
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
    billetes: {
      type: Array,
      default: [],
    },
    monedas: {
      type: Array,
      default: []
    }
  },
  computed: {

  },
  methods: {
    mtdClose() {
      this.$emit("closeModalArqueo");
    },
    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>